export default __webpack_public_path__ + "static/media/2017 DEC ZURY PASSION-05.fd67a641.jpg";